<template>
  <sub-page title="我的认证">
    <div class="auth-page">
      <!-- 顶部渐变用户卡片 -->
      <div>
        <img src="@/assets/icons/mine-avatar.png" class="user-avatar" alt="头像" />
        <!-- <div class="user-meta">
          <div class="user-name">**杰</div>
          <div class="user-id">34**************19</div>
        </div> -->
        <!-- 右侧「已实人」绿色印章 -->
        <!-- <svg viewBox="0 0 100 100" class="stamp">
          <defs>
            <path id="stampArc" d="M 14 52 A 38 38 0 1 1 86 52" fill="none"/>
          </defs>
          <circle cx="50" cy="50" r="46" fill="none" stroke="rgba(255,255,255,0.55)" stroke-width="2"/>
          <circle cx="50" cy="50" r="38" fill="none" stroke="rgba(255,255,255,0.85)" stroke-width="2.5" stroke-dasharray="3 4"/>
          <text fill="#1F7A52" font-size="17" font-weight="bold">
            <textPath xlink:href="#stampArc" href="#stampArc" startOffset="50%" text-anchor="middle">已实人</textPath>
          </text>
          <path d="M38 50 L47 59 L63 40" fill="none" stroke="#1F7A52" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg> -->
      </div>

      <!-- 实名认证分组 -->
      <div class="group-title">实名认证</div>
      <div class="group-card">
        <div class="auth-row">
          <span class="row-icon icon-realname">
            <svg viewBox="0 0 48 48" class="icon-svg">
              <rect x="4" y="4" width="40" height="40" rx="10" fill="#2E8CF6"/>
              <circle cx="22" cy="19" r="6.5" fill="#fff"/>
              <path d="M11 38 C11 29 16 25 22 25 C28 25 33 29 33 38 Z" fill="#fff"/>
              <circle cx="35" cy="34" r="8" fill="#fff"/>
              <path d="M31.5 34 L34 36.5 L39 31" fill="none" stroke="#2E8CF6" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="row-name">实名认证</span>
          <span class="status-tag">已实名</span>
        </div>
      </div>

      <!-- 实人认证分组 -->
      <div class="group-title">实人认证</div>
      <div class="group-card">
        <div class="auth-row">
          <span class="row-icon icon-face">
            <svg viewBox="0 0 48 48" class="icon-svg">
              <rect x="4" y="4" width="40" height="40" rx="10" fill="#2E8CF6"/>
              <!-- 扫描角框 -->
              <path d="M14 19 v-2 a2 2 0 0 1 2 -2 h2 M30 15 h2 a2 2 0 0 1 2 2 v2 M34 29 v2 a2 2 0 0 1 -2 2 h-2 M18 33 h-2 a2 2 0 0 1 -2 -2 v-2" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
              <!-- 人脸 -->
              <circle cx="24" cy="23" r="4.5" fill="none" stroke="#9CC8FB" stroke-width="2"/>
              <path d="M17 32 C18 28 21 27 24 27 C27 27 30 28 31 32" fill="none" stroke="#9CC8FB" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </span>
          <span class="row-name">人脸认证</span>
          <span class="status-tag">已实人</span>
        </div>
        <div class="auth-row bordered">
          <span class="row-icon">
            <img :src="cardImg" class="row-card-img" alt="电子社保卡认证" />
          </span>
          <span class="row-name">电子社保卡认证</span>
          <span class="status-tag">已实人</span>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MyAuth',
  components: { SubPage },
  data() {
    return {
      // 电子社保卡认证图标（红色官方原图，与人脸认证同为方形展示，不做圆形裁切）
      cardImg: require('@/assets/icons/cert-card.png')
    }
  }
}
</script>

<style scoped>
.auth-page {
  min-height: 100%;
  background: #F8F8F8;
  padding-bottom: calc(60 * var(--w));
}

/* 顶部渐变卡片 */
.user-card {
  margin: calc(28 * var(--w)) calc(28 * var(--w)) 0;
  height: calc(300 * var(--w));
  border-radius: calc(24 * var(--w));
  background: linear-gradient(100deg, #3D8FD6 0%, #35B49A 100%);
  display: flex;
  align-items: center;
  padding: 0 calc(48 * var(--w));
}
.user-avatar {
  width: 100%;
  /* height: calc(150 * var(--w)); */
 
  object-fit: cover;
  flex-shrink: 0;
}
.user-meta {
  flex: 1;
  margin-left: calc(40 * var(--w));
  min-width: 0;
}
.user-name {
  font-size: calc(52 * var(--w));
  font-weight: bold;
  color: #fff;
}
.user-id {
  margin-top: calc(16 * var(--w));
  font-size: calc(40 * var(--w));
  color: #fff;
}
.stamp {
  width: calc(170 * var(--w));
  height: calc(170 * var(--w));
  flex-shrink: 0;
}

/* 分组标题 */
.group-title {
  padding: calc(20 * var(--w)) calc(40 * var(--w)) calc(28 * var(--w));
  font-size: calc(44 * var(--w));
  font-weight: 500;
  color: #1A1A1A;
}

/* 白色分组卡片 */
.group-card {
  margin: 0 calc(28 * var(--w));
  background: #fff;
  border-radius: calc(20 * var(--w));
  overflow: hidden;
}
.auth-row {
  position: relative;
  display: flex;
  align-items: center;
  height: calc(170 * var(--w));
  padding: 0 calc(40 * var(--w));
}
.auth-row.bordered::before {
  content: '';
  position: absolute;
  left: calc(40 * var(--w));
  right: calc(40 * var(--w));
  top: 0;
  border-top: 1px solid #F0F0F0;
}
.row-icon {
  width: calc(96 * var(--w));
  height: calc(96 * var(--w));
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-svg {
  width: 100%;
  height: 100%;
}
/* 电子社保卡认证：与其他人脸认证图标占位一致（96×96 方形），
   官方红色卡图按比例完整显示，不加圆形 */
.row-card-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.row-name {
  flex: 1;
  margin-left: calc(32 * var(--w));
  font-size: calc(44 * var(--w));
  color: #1A1A1A;
}
/* 右侧状态标签 */
.status-tag {
  flex-shrink: 0;
  min-width: calc(168 * var(--w));
  height: calc(76 * var(--w));
  padding: 0 calc(20 * var(--w));
  border: calc(2 * var(--w)) solid #D88230;
  border-radius: calc(14 * var(--w));
  color: #D88230;
  font-size: calc(36 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyAuth.vue